import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateFolderRequestFailure() {
      return getState().isFailure;
    },
    isCreateFolderRequestPending() {
      return getState().isPending;
    },
    isCreateFolderRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
